import React, { FC, useEffect, useState } from "react";
import { Button, InputField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import Datepicker from "../../generic/Datepicker";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import { contractTypes } from "../../../constant/data";

export default (props: any) => {
  var { control, handleSubmit, watch } = useForm();
  const contracttypepicker = usePickerhook();
  const departmentPickhook = usePickerhook();
  const startdatepick = usePickerhook();
  const enddatepick = usePickerhook();
  const { selectedOrgDepts } = useDepartmentHook();
  const { setLoading } = useStateSetter();
  const { AddEmployee } = useEmployeeHook();
  const [error, seterror] = useState("");
  const [condition, setcondition] = useState(false);

  const watchedFields = watch(["title", "description"]);

  const { SelectedOrg, config } = useStateGetter();
  const [duration, setduration] = useState(0);

  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" &&
      field !== undefined &&
      condition &&
      contracttypepicker.pickedRole
  );

  const onSubmit = async (data: any) => {
    var postdata = {
      title: data.title,
      contractType: contracttypepicker.pickedRole.name,
      startDate: new Date (startdatepick.pickedRole.name).toISOString(),
      endDate: new  Date (enddatepick.pickedRole.name).toISOString(),
      description: data.description,
      organizationID: SelectedOrg.id,
    };
    setLoading(true);

    await props.AddHoliday(postdata);

    props.show(false);

    setLoading(false);
    props.refresh();
  };

  function getduration() {
    var date1 = new Date(startdatepick.pickedRole.code);
    var date2 = new Date(enddatepick.pickedRole.code);

    const timeDifference = date2.getTime() - date1.getTime(); // Difference in milliseconds
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24); // Convert to day
    return Math.round(daysDifference);
  }
  useEffect(() => {
    if (startdatepick.pickedRole && enddatepick.pickedRole) {
      setduration(getduration());
    }
  }, [startdatepick, enddatepick]);

  useEffect(() => {
    if (duration < 0) {
      setcondition(false);

      seterror("Invalid Start date/End date");
    } else {
      setcondition(true);
      seterror("");
    }
  }, [duration]);
  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col    rounded-[8px] bg-white w-[40vw] p-4 ">
          <p className="font-semibold self-start text-sm ">New Holiday</p>
          <div className="   	 ">
            <InputField
              name="title"
              title="Holiday title"
              placeholder={"Enter title"}
              control={control}
              rules={{
                required: "title is required",
                pattern: {
                  value: textReg,
                  message: "Invalid title",
                },
              }}
            />

            <div className="grid grid-cols-2 gap-4">
              <ListPicker
                fullwidth
                hook={contracttypepicker}
                title="Contract Type"
                list={[{name:"Parttime", code:"Parttime"}, {name:"Fulltime", code:"Fulltime"}]}
              />
            </div>
            <div className=" flex gap-2 w-full">
              <Datepicker
                defaultvalue={{
                  code: new Date(),
                  name: new Date().toISOString(),
                }}
                hook={startdatepick}
                title="Start date"
              />

              <Datepicker
                defaultvalue={{
                  code: new Date(),
                  name: new Date().toISOString(),
                }}
                hook={enddatepick}
                title="End date"
              />

              <div className="my-4 max-w-[150px] cursor-pointer">
                <p className="text-xs mb-2 flex  items-center">Duration</p>
                <div className=" px-4 py-2  flex text-sm bg-gray-100 w-full  rounded-[8px] items-center">
                  <p>{duration}</p>
                </div>
              </div>
            </div>
            <InputField
              name="description"
              title="Holiday description"
              placeholder={"Enter description"}
              isTextArea
              control={control}
              rules={{
                required: "description is required",
                pattern: {
                  value: textReg,
                  message: "Invalid description",
                },
              }}
            />
          </div>

          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
              disabled={!areFieldsFilled}
              text="Add Holiday"
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};
